import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'
import { useStore } from 'vuex'
import Loading from '@/components/common/loading.vue'
import { AppGettersTypes, AppMutationTypes } from '@/store/modules/app'
import { getOption, getLocationOption, getLocale } from './services/modules/app'
import type { OptionType } from '@/types/commonType'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const isLoading_resource = ref(false) // 資源是否載入: locale 語系

// 語系初始化
const initLocale = async () => {
  // 1.檢查是否已儲存語言
  const storeLanguage = store.getters[AppGettersTypes.GET_LANG]
  if (storeLanguage) return

  try {
    // 2.取得系統支援語言
    const { data } = await getOption('array', 'locale_native')
    const localeOption = data.data.locale_native

    // 3.檢查瀏覽器預設語言是否支援 => 是:儲存瀏覽器語言 否:儲存系統支援語言第一筆
    const browserDefaultLang = navigator.language
    const isLanguageSupported = localeOption.find((lang: OptionType) => lang.value === browserDefaultLang)
    if (isLanguageSupported) {
      // 瀏覽器預設語言
      store.commit(AppMutationTypes.SET_LANG, browserDefaultLang)
    } else {
      // 系統支援語言第一筆
      store.commit(AppMutationTypes.SET_LANG, localeOption[0].value)
    }
  } catch (error) {
    store.commit(AppMutationTypes.SET_LANG, 'zh-TW')
  }
}

// 取得語系資料
const getLocaleData = async () => {
  try {
    const { data: locale } = await getLocale()
    store.commit(AppMutationTypes.SET_LOCALE, locale.data)
  } catch (error) {
    // error
  } finally {
    isLoading_resource.value = true // 允許子層開始渲染
  }
}

const init = async () => {
  // store.commit(AppMutationTypes.SET_ISLOADING, true)

  await initLocale()
  await getLocaleData()

  // 載入選項, 地區
  const p1 = getOption()
  const p2 = getOption('object')
  Promise.all([p1, p2])
    .then((res) => {
      store.commit(AppMutationTypes.SET_OPTION, res[0].data.data)
      store.commit(AppMutationTypes.SET_OPTION_OBJECT_TYPE, res[1].data.data)
    })
    .catch(() => {
      // error
    })
    .finally(() => {
      // store.commit(AppMutationTypes.SET_ISLOADING, false)
    })
}
// init read setting
;(async () => {
  await init()
})()

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Loading),
    (isLoading_resource.value)
      ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})